import grapesjs from 'drapcode-builder';
import loadComponents from './components';

export default grapesjs.plugins.add('signature-pad', (editor, opts = {}) => {
  const default_types = { signaturePad: 'signature-pad' };
  const default_labels = { signaturePad: 'Signature Pad' };
  const options = {
    ...{
      labels: default_labels,
      types: default_types,
      signaturePadCategory: 'Signature Pad',
    },
    ...opts,
  };

  loadComponents(editor, options);
});
